<template>
  <div class="download-version">
    <b-img src="../../assets/u3_banner.jpg" fluid></b-img>
    <b-card>
      <b-card-text>
        <b-container fluid>
          <b-row>
            <b-col cols="8">
              <h3>Cloud Client for U3 and newer</h3>
              <a href="https://docs.google.com/document/d/1Pp-A3tDFYaAz3yv1jMojitlcD_M2T50zcjA8RUZSTRE/view" target="_blank">3DPrinterOS on Ultimaker 3 installation guide v1.1</a>
            </b-col>
            <b-col cols="4" style="text-align: right">
              <b-img src="../../assets/u3_logo.png"></b-img>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <strong>Execute in the command line of Ultimaker 3 or newer Ultimaker printer:</strong>
              <br />
              <div class="code-block">
                <b-row align-v="center">
                  <b-col cols="10">
                    <samp>{{code}}</samp>
                  </b-col>
                  <b-col cols="2" class="text-right">
                    <b-button variant="-primary" size="-small" id="copy-button-u3" @click="copyToClipboard">copy to clipboard</b-button>
                  </b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>
        </b-container>
      </b-card-text>
    </b-card>
  </div>
</template>

<script>
  export default {
    name: 'ultimaker-client-installation',
    props: ['cmd'],
    computed: {
      code() {
        return this.cmd;
      }
    },
    methods: {
      copyToClipboard () {
        let inputToCopy = document.createElement('input');
        inputToCopy.value = this.code;
        document.body.append(inputToCopy);
        inputToCopy.select();
        document.execCommand('copy');
        if (window.getSelection) {
          window.getSelection().removeAllRanges();
        }
        inputToCopy.remove();
      },
    }
  }
</script>